export default __webpack_public_path__ + "static/media/SmartBandhan_hand_right.3ced15a2.png";